import React from "react";

const TABS = [
  { id: "overview", label: "Overview", icon: "LayoutDashboard" },
  { id: "financials", label: "Financials", icon: "BarChart2" },
  { id: "risks", label: "Key Risks", icon: "ShieldAlert" },
  { id: "esg", label: "ESG", icon: "Leaf" },
  { id: "documents", label: "Documents", icon: "FolderOpen" },
  { id: "dealterms", label: "Deal Terms", icon: "FileText" },
];

export default function TabNavigation({ activeTab, onTabChange }) {
  return (
    <div className="bg-card border-b border-border sticky top-0 z-10">
      <div className="px-6 md:px-10 lg:px-12">
        <div className="overflow-x-auto">
          <div className="flex gap-0 min-w-max">
            {TABS?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => onTabChange(tab?.id)}
                className={`flex items-center gap-2 px-4 py-3 md:py-4 text-sm font-caption font-medium border-b-2 transition-all duration-200 whitespace-nowrap ${
                  activeTab === tab?.id
                    ? "border-primary text-primary" :"border-transparent text-muted-foreground hover:text-foreground hover:border-border"
                }`}
                aria-current={activeTab === tab?.id ? "page" : undefined}
              >
                {tab?.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}